var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavicon02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99976 8.99915C2.79533 8.99915 3.55832 9.31519 4.12088 9.87774C4.68344 10.4403 4.99948 11.2033 4.99948 11.9989C4.99948 12.7944 4.68344 13.5574 4.12088 14.12C3.55832 14.6826 2.79533 14.9986 1.99976 14.9986V16.9984C1.99976 17.5288 2.21045 18.0375 2.58549 18.4125C2.96053 18.7875 3.46919 18.9982 3.99957 18.9982H19.9981C20.5285 18.9982 21.0372 18.7875 21.4122 18.4125C21.7872 18.0375 21.9979 17.5288 21.9979 16.9984V14.9986C21.2023 14.9986 20.4394 14.6826 19.8768 14.12C19.3142 13.5574 18.9982 12.7944 18.9982 11.9989C18.9982 11.2033 19.3142 10.4403 19.8768 9.87774C20.4394 9.31519 21.2023 8.99915 21.9979 8.99915V6.99933C21.9979 6.46894 21.7872 5.96028 21.4122 5.58524C21.0372 5.21021 20.5285 4.99951 19.9981 4.99951H3.99957C3.46919 4.99951 2.96053 5.21021 2.58549 5.58524C2.21045 5.96028 1.99976 6.46894 1.99976 6.99933V8.99915Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9988 4.99951V6.99951",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9988 16.9984V18.9984",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9988 10.999V12.999",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon02);
export default __webpack_public_path__ + "static/media/navicon02.26e0d47a5274790728dc7c2b90eb9d19.svg";
export { ForwardRef as ReactComponent };